import { format } from 'date-fns'
import React from 'react'
import Realty from '../../../models/Realty'
import { currencyFormat } from '../../../utils/form-validations'
import Table from '../../Table'

interface Props {
  realty: Realty
}

const RealtyProposals: React.FC<Props> = ({ realty }) => {

  const getStatus = (proposal: any) => {
    const status: string = proposal.status
    switch (status) {
      case 'rejected':
        return <span style={{ color: 'red' }}>Rejeitada</span>
      case 'analysing':
        return 'Em análise'
      case 'approved':
        return 'Aprovado'

      default:
        break;
    }
  }

  if (realty.proposals && realty.proposals.length) {
    return (
      <>
        <Table
          header={[
            'Data',
            'Proposta',
            'Descrição',
            'Estado',
          ]}
          items={realty.proposals.map((proposal: any) => [
            format(new Date(proposal.created_at || new Date()), 'dd/MM/yyyy HH:mm'),
            `R$ ${currencyFormat(proposal.amount)}`,
            proposal.description,
            getStatus(proposal),
          ])}
          onClick={item => {
          }}
        />
      </>
    )
  } else return (<></>)
}

export default RealtyProposals
